import {useState, useEffect, useContext} from 'react'
import {Helmet} from "react-helmet";
import {ViewContext} from '../../../Components/Contexts/ViewContext.js';
import useFetch from '../../../Components/APIs/SpotifyGetArtist.js'; 
import {Link,useNavigate,useSearchParams, useParams} from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import NavigationMenuToggle from '../../../Components/Navigation/NavigationMenuToggle.js';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import Albums from '../../../Components/SpotifyProfile/Browse/Albums.js';
import Songs from '../../../Components/SpotifyProfile/Browse/Songs.js';
import MoreSongs from '../../../Components/SpotifyProfile/Browse/Sub/Songs.js';
import MoreAlbums from '../../../Components/SpotifyProfile/Browse/Sub/Albums.js';
import Filter from "../../../Components/SpotifyProfile/Browse/Filter.js"
import IsLoading from '../../../Components/isLoading.js';
import { prominent } from 'color.js';
import ConvertNum from '../../../Components/ConvertNumbers/useConvertLargeNum';
import { GeneralFunctionsContext } from '../../../Components/Contexts/GeneralFunctionsContext.js';
export default function ProfileContainer ({props}) {
    const {setViewUserData} = useContext(ViewContext)

    const navigate = useNavigate();
   
     const {innerWidth, offset} = useContext(GeneralFunctionsContext);
    
    const [pagescroll, setPageScroll] = useState(0)
    useEffect(()=>{
        window.scrollTo(0, 0)
        window.onscroll = () => {
            setPageScroll(window.pageYOffset)
        }
    },[])


    const {user_id} = useParams();

    const [searchParams, setSearchParams] = useSearchParams();
    const group_param = searchParams.get("group")
    const search_param = searchParams.get("search")
    const sort_param = searchParams.get("sort")
    const genre_param = searchParams.get("genre")
    const role_param = searchParams.get("role")


    const [search_string,setSearchString] = useState('');

    useEffect(()=>{
        if(search_param){
            setSearchString(search_param)
        }else{
            setSearchString('')
        }
        
    },[search_param])
   

    const [total_singles, setTotalSingles] = useState(0);
    const [total_albums, setTotalAlbums] = useState(0);
    
    const [data, setData] = useState(null);
    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    useEffect(()=>{
        if(FetchedData){
              setData(FetchedData)
              setViewUserData(
                {
                    "id": FetchedData.id,
                    "user_id": FetchedData.id,
                    "artist_name": FetchedData.name,
                    "img_url": FetchedData.images.length>0?FetchedData.images[1].url:"",
                    "platform": "spotify"
                }
            );
        }
    },[FetchedData])
    
    const send_request =()=>{
        setData(null)
        setRequest({
            "user_id":user_id,
            "search_string":"",
            "role":"",
            "sort":"topfollowed",
            "page":"",
        })
    }

    useEffect(()=>{
        send_request()
    },[user_id])
  

    const onhandle_search_string = (e) =>{
        if(e.target.value.length<50){
            const isGenre = genre_param?"&genre="+genre_param:"";
            const isSort =  sort_param?"&sort="+sort_param:"";
            const isSearch = e.target.value?"&search="+e.target.value.replace(/\s/g, "%20"):"";
            const isRole =  role_param?"&role="+role_param.replace(/\s/g, "%20"):"";

            if(group_param==="all"){
                navigate("/spotify/profile/browse/"+user_id+"?group=all"+isSearch+isSort+isGenre+isRole, { replace: true })
                document.title = data.name + "'s Library";
            }else if(group_param==="songs"){
                navigate("/spotify/profile/browse/"+user_id+"?group=songs"+isSearch+isSort+isGenre+isRole, { replace: true })
                document.title = data.name + "'s Library - Songs";
            }else if(group_param==="albums"){
                navigate("/spotify/profile/browse/"+user_id+"?group=albums"+isSearch+isSort+isGenre+isRole, { replace: true })
                document.title = data.name + "'s Library - Albums";
            }else{
                navigate("/spotify/profile/browse/"+user_id+"?group=all"+isSearch+isSort+isGenre+isRole, { replace: true })
                document.title = data.name + "'s Library";
            }
        }
       
    }
    const [filters,setFilter] = useState({
        "search_string": search_param?search_param:"",
        "user_id": user_id,
        "search_string": search_param?search_param:"",
        "sort": sort_param?sort_param:"",
        "genre": genre_param?genre_param:"",
    });

    useEffect(()=>{
        setFilter({
            "search_string": search_param?search_param:"",
            "user_id": user_id,
            "search_string": search_param?search_param:"",
            "sort": sort_param?sort_param:"",
            "genre": genre_param?genre_param:"",
        })
    },[group_param,search_param,sort_param,genre_param])


    const[isFilterOpened,  setFilterOpened] = useState(false)


    const removeQueryParam = (param)=>{
        if (searchParams.has(param)) {
            const token = searchParams.get(param);
            if (token) {
              searchParams.delete(param);
              setSearchParams(searchParams);
            }
        }
    }
    const[BGColor,setBGColor] = useState(null)
    
    useEffect(()=>{
        if(data){
               
                if(data.images.length>0 && data.images[1]){
                    setViewUserData(
                        {
                            "id": data.id,
                            "user_id": data.id,
                            "artist_name": data.name,
                            "img_url": data.images[1].url,
                            "platform": "spotify"
                        }
                    );
                    prominent(data.images[1].url,{format: 'hex',group: 30}).then(colors => {
                        setBGColor(colors[1]) 
                    })
                }else{
                    setBGColor('#181818') 
                }
            
        }
        
    },[data])

    const goto=(d)=>{
        const isSort =  sort_param?"&sort="+sort_param:"";
        const isSearch = search_param?"&search="+search_param.replace(/\s/g, "%20"):"";
        const isGenre = genre_param?"&genre="+genre_param:"";
        const isRole =  role_param?"&role="+role_param.replace(/\s/g, "%20"):"";

        if(d==="All"){
            return "/spotify/profile/browse/"+user_id+"?group=all"+isSearch+isSort+isGenre+isRole;
        }else if(d==="Singles"){
            return "/spotify/profile/browse/"+user_id+"?group=songs"+isSearch+isSort+isGenre+isRole;
        }else if(d==="Albums"){
            return "/spotify/profile/browse/"+user_id+"?group=albums"+isSearch+isSort+isGenre+isRole;
        }else{
            return "/spotify/profile/browse/"+user_id+"?group=all"+isSearch+isSort+isGenre+isRole;
        }
    }
    return (
        <>
        {data?
        <>
       
            <Helmet>
                <title>{data.name+"'s Library"}</title>
                <meta property="og:title" content={data.name+"'s Library"}/>
                <meta name="title" content={data.name+"'s Library"}/>
                <meta name="description" content="Check out this profile on Geniux Music." key="3"/>
                {(data.images.length>0 && data.images[1])?
                <meta property="og:image" content={data.images[1].url}/>:
                <meta property="og:image" content="/assets/images/geniuxbanner.jpeg"/>
                }
                
            </Helmet>
            <div className="navbar" style={{"--userbannerbg": BGColor}}>
                <div className="wrapper">
                    <div className="lft">
                        <IconButton className="icon" onClick={()=>navigate(-1)}>
                            <ArrowBackIcon />
                        </IconButton> 
                        <div className="titles">
                            <p>PROFILE</p>
                            {pagescroll> 80 &&(
                                <>
                                {data.name.length<40?
                                    <p>{data.name}</p>:
                                    <p>{data.name.substring(0, 40) + "..."}</p> 
                                }
                                </>
                            )}
                        </div>
                        
                    </div>
                    <div className="rgt">
                        <NavigationMenuToggle/>
                    </div>  
                </div>
                
            </div>
            <div className="mycontainer">
                <div className="userbanner02">
                    <div className="background" style={{backgroundColor: BGColor}}></div>
                    
                    <div className="user">
                        <div className='wrapper'>
                        <Link to={"/spotify/profile/"+user_id}>
                            <div className="lf" onClick={()=>navigate("/spotify/profile/"+user_id)}>
                                {(data.images.length>0 && data.images[1])?
                                    <img className="ppimg" src={data.images[1].url}/>
                                :
                                    <div className="ppimg">
                                        {data.name.substring(0, 1)}
                                    </div>
                                }
                                <div className="details">
                                    <p>{data.name}</p>
                                    <p>{data.type}</p>
                                </div>
                            </div>
                        </Link>

                        <div className="rt">
                            <div className="details">
                                <p onClick={()=>navigate("/spotify/profile/browse/"+user_id+"?group=songs")}>Singles <span><ConvertNum num = {total_singles}/></span></p>
                                <p onClick={()=>navigate("/spotify/profile/browse/"+user_id+"?group=albums")}>Albums <span><ConvertNum num = {total_albums}/></span></p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="wrapper">
                    
                    <div className="FilterPanel">
                            {/* <div className="searchbar">
                                <SearchIcon/>
                                <input placeholder={"Search "+data.name}  value={search_param?search_param:""}  onChange={onhandle_search_string}/>
                            </div> */}
                
                            <div className="filter">
                                <div className="lft">
                                    <Link to={goto("All")}>
                                        <Button color="secondary" className={group_param==="all" || !group_param?"active":""}><p>All</p></Button>
                                    </Link>
                                    <Link to={goto("Singles")}>
                                        <Button color="secondary" className={group_param==="songs"?"active":""}><p>Singles</p></Button>   
                                    </Link>
                                    <Link to={goto("Albums")}>
                                        <Button color="secondary" className={group_param==="albums"?"active":""}><p>Albums</p></Button>
                                    </Link>
                                    
                                </div>
                                <div className="rgt">
                                    {innerWidth<992?<IconButton color="secondary" className="" onClick={()=>setFilterOpened(true)}><MoreVertRoundedIcon/></IconButton>:
                                    <><div className="separator"></div><Button color="secondary" onClick={()=>setFilterOpened(true)}>Filter</Button></>}
                                </div>
                            </div>
                            <div className="keywords">
                                {filters.search_string!==""&&(
                                    <Button color="secondary"><p>SEARCH: {filters.search_string.length>15?filters.search_string.substring(0,15)+"...":filters.search_string}</p><CancelIcon onClick={()=>removeQueryParam('search')}/></Button>
                                )}
                                {filters.sort!==""&&(
                                    <Button color="secondary"><p onClick={()=>setFilterOpened(true)}>SORT: {filters.sort==="played"?"Popular":filters.sort==="random"?"Shuffle":filters.sort}</p><CancelIcon onClick={()=>removeQueryParam('sort')}/></Button>
                                )}
                                {filters.genre!==""&&(
                                    <Button color="secondary"><p>GENRE: {filters.genre}</p><CancelIcon  onClick={()=>removeQueryParam('genre')}/></Button>
                                )}
                            </div>
                    </div>
                    <br/>
                    {group_param=="songs"?
                        <>
                        <Helmet>
                            <title>{data.name+"'s Library - Songs"}</title>
                            <meta property="og:title" content={data.name+"'s Library - Songs"}/>
                            <meta name="title" content={data.name+"'s Library - Songs"}/>
                        </Helmet>
                            <MoreSongs filters={filters} innerWidth={innerWidth} setTotalSingles={setTotalSingles}/>

                        </>:
                        group_param=="albums"?
                        <>
                            <Helmet>
                                <title>{data.name+"'s Library - Albums"}</title>
                                <meta property="og:title" content={data.name+"'s Library - Albums"}/>
                                <meta name="title" content={data.name+"'s Library - Albums"}/>
                            </Helmet>
                            <MoreAlbums filters={filters} innerWidth={innerWidth} setTotalAlbums = {setTotalAlbums}/>             
                        </>:
                        <>
                            <Helmet>
                                <title>{data.name+"'s Library"}</title>
                                <meta property="og:title" content={data.name+"'s Library"}/>
                                <meta name="title" content={data.name+"'s Library"}/>
                            </Helmet>

                            <Songs filters={filters} innerWidth={innerWidth} setTotalSingles={setTotalSingles}/>
                            <Albums filters={filters} innerWidth={innerWidth} setTotalAlbums = {setTotalAlbums}/>
                        </>
                    }
                    
                    
                </div>
            </div>
            {isFilterOpened && (
                <Filter user_data = {data} setFilterOpened={setFilterOpened} filters = {filters} group_param={group_param} />
            )}
            
        </>:
        data && !data.name?
        <>
            <Helmet>
                <title>User not found</title>
                <meta property="og:title" content="User not found" />
                <meta name="title" content="User not found"/>
                <meta name="description" content="Link might be invalid or user has been removed"/>
                <meta property="og:image" content="/assets/images/geniuxbanner.jpeg"/>
            </Helmet>
            <div className="navbar">
                <div className="wrapper">
                    <div className="lft">
                        <IconButton className="icon" onClick={()=>navigate(-1)}>
                            <ArrowBackIcon />
                        </IconButton> 
                        <div className="titles">
                            <p>PROFILE</p>
                            {pagescroll> 80 &&(
                                <>
                                    <p>{user_id}</p>
                                </>
                            )}
                        </div>
                        
                    </div>
                    <div className="rgt">
                        <NavigationMenuToggle/>
                    </div>  
                </div>
                
            </div>
        </>:
        error==="network_err"?
        <>
        <Helmet>
            <title>No Internet</title>
            <meta property="og:title" content="No Internet"/>
            <meta name="title" content="No Internet"/>
            <meta name="description" content="Check your internet connectivity" />
            <meta property="og:image" content="/assets/images/geniuxbanner.jpeg"/>
                
           
        </Helmet>
        <div className="navbar">
            <div className="wrapper">
                <div className="lft">
                    <IconButton className="icon" onClick={()=>navigate(-1)}>
                        <ArrowBackIcon />
                    </IconButton> 
                
                    <div className="titles">
                        <p>Browse</p>
                        {/* <p>{user_id}</p> */}
                    </div>
                
    
                </div>
                <div className="rgt">
                    <NavigationMenuToggle/>
                </div>
            </div>
        </div>
        <div className="mycontainer">
            {/* {innerWidth>992 &&(
                <div className="mypath">
                    <div className="wrapper ">
                        <div className="lft">
                        {window.history.length>1?
                            <Button onClick={()=>navigate(-1)}>
                            <KeyboardBackspaceIcon/>
                            </Button>  
                            :
                            <Button onClick={()=>navigate(-1)} disabled="true">
                                <KeyboardBackspaceIcon/>
                            </Button>  
                        }
                        </div>
                        <div className="rgt">
                            <p>
                                <Link to="" className="active">Browse</Link>
                                <Link to="" className="">/ {user_id}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            )} */}
            {(!isLoading) &&(
                <div className='wrapper'>
                    <div className="no_data_msg">
                        <div className="container">
                            <div className="icon">
                                <img src="/assets/images/no_user_found.svg" />
                            </div>
                            <p>Check your internet connectivity</p> 
                            <Button onClick={()=>send_request()}>
                                Retry
                            </Button>
                        </div>
                    </div>
                </div> 
            )}  
        </div>
        </>:
        isLoading?
        <>
        <div className="navbar">
            <div className="wrapper">
                <div className="lft">
                    <IconButton className="icon" onClick={()=>navigate(-1)}>
                        <ArrowBackIcon />
                    </IconButton> 
                
                    <div className="titles">
                        <p>Profile</p>
                    </div>
                
    
                </div>
                <div className="rgt">
                    <NavigationMenuToggle/>
                </div>
            </div>
        </div>
        <div className="mycontainer">
            {/* {innerWidth>992 &&(
                <div className="mypath">
                    <div className="wrapper ">
                        <div className="lft">
                        {window.history.length>1?
                            <Button onClick={()=>navigate(-1)}>
                            <KeyboardBackspaceIcon/>
                            </Button>  
                            :
                            <Button onClick={()=>navigate(-1)} disabled="true">
                                <KeyboardBackspaceIcon/>
                            </Button>  
                        }
                        </div>
                        <div className="rgt">
                            <p>
                                <Link to="" className="active">Browse</Link>
                                <Link to="" className="">/ {user_id}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            )} */}
          
            <div className='wrapper'>
                <IsLoading/>
            </div> 
            
        </div>
        </>:<></>
        }
        </>
    )
}

